module.exports = __webpack_public_path__ + "static/media/3.c14eac40.jpg";